// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WrappedFpsReceiverNameAPIModel
 */
export interface WrappedFpsReceiverNameAPIModel {
    /**
     * 
     * @type {string}
     * @memberof WrappedFpsReceiverNameAPIModel
     */
    name: string;
}

export function WrappedFpsReceiverNameAPIModelFromJSON(json: any): WrappedFpsReceiverNameAPIModel {
    return WrappedFpsReceiverNameAPIModelFromJSONTyped(json, false);
}

export function WrappedFpsReceiverNameAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): WrappedFpsReceiverNameAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function WrappedFpsReceiverNameAPIModelToJSON(value?: WrappedFpsReceiverNameAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


